import { MutationHookOptions, OperationVariables } from "@apollo/client";
import { useCallback, useMemo } from "react";
import { useSnackbarMutation } from "../../hooks";
import { BuildingMedia } from "../models/BuildingMedia";
import { MUTATIONS } from "../mutations";

type UpdateBuildingRoomMediaScope = "CREATE" | "UPDATE";

export function useCreateOrUpdateBuildingMedia(
  scope: UpdateBuildingRoomMediaScope,
  opts: MutationHookOptions<any, OperationVariables> = {}
) {
  const mutation = useMemo(() => {
    return scope === "CREATE"
      ? MUTATIONS.CREATE_BUILDING_MEDIA
      : MUTATIONS.UPDATE_BUILDING_MEDIA;
  }, [scope]);

  const [invokeCreateOrUpdate, { loading, error }] = useSnackbarMutation(
    mutation,
    opts
  );

  const createOrUpdate = useCallback(
    (data: Partial<BuildingMedia>) => {
      let variables: any = {
        buildingMedia: { ...data },
      };
      delete variables.buildingMedia.id;
      if (scope === "UPDATE") {
        variables.buildingMediaId = data.id;
      }
      invokeCreateOrUpdate({
        variables,
      });
    },
    [invokeCreateOrUpdate, scope]
  );

  return { createOrUpdate, loading, error };
}
